// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"633":"75b72e30","749":"001cf7b4","903":"afd96469","959":"926f51e8"}[chunkId] + ".chunk.js";
};